import React, { useEffect, useRef, useState } from 'react';
import Actions from '../../../actions/actions';
import { TextField } from '@mui/material';
import FileCopyIcon from '@mui/icons-material/FileCopy';

export default function CopyLink() {
  const [url, setUrl] = useState('');
  useEffect(() => {
    if (!url) {
      Actions.getGenericMarketingUrl().then(setUrl);
    }
  }, [url]);
  const urlInputRef = useRef();

  const copyToClipboard = () => {
    /* Select the text field */
    urlInputRef.current.select();
    urlInputRef.current.setSelectionRange(0, 99999); /* For mobile devices */

    /* Copy the text inside the text field */
    document.execCommand('copy');

    Actions.setMessages('Your pre-qualification link has been copied to your clipboard');
  };
  return (
    <div className="copy-link-container">
      Your prospective customers can use this link to submit pre-qualification applications. It can be shared via email,
      on your website, or on social media. You will be notified when new applications come in.
      <div className="url-copy">
        <TextField
          className="qa-qc-copy-link-url text-field"
          fullWidth={true}
          size="small"
          margin="dense"
          variant="outlined"
          label="URL"
          value={url}
          inputProps={{ readOnly: true }}
          inputRef={urlInputRef}
        />
        <button className="qa-qc-copy-link-button link-button" onClick={copyToClipboard}>
          <FileCopyIcon fontSize="large" className="copy-icon" />
        </button>
      </div>
    </div>
  );
}
